import { render } from "./model-attribute-tr.html?vue&type=template&id=7822e0e4&scoped=true&ts=true"
import script from "./model-attribute-tr.ts?vue&type=script&lang=ts"
export * from "./model-attribute-tr.ts?vue&type=script&lang=ts"

import "./model-attribute-tr.scss?vue&type=style&index=0&id=7822e0e4&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7822e0e4"]])

export default __exports__